import { useAppSelector } from '../../store/hooks'
import './LoadingScreen.scss'

export default function LoadingScreen() {


  const zart = useAppSelector(state => state.sharedState.showLoading);

  return (
    <>
      {
        zart &&
        <div className='loading-screen'>
          <div className='loading-container'>
            <img className='loading-icon' src="stb-logo.png" />
            <h1 className='loading-text'>Lütfen Bekleyiniz ...</h1>
          </div>
        </div>
    }
    </>
  )
}

